import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchProjectsIfNeeded } from 'data/actions/projects';

import ProjectGrid from 'components/organisms/projectGrid';

class otherProjectsContainer extends Component {
    componentDidMount() {
        this.props.fetchProjectsIfNeeded();
    }

    componentDidUpdate(prevProps, prevState) {}

    render() {
        return <ProjectGrid {...this.props} />;
    }
}

function getNextProjects(projects, start, count) {
    let nextProjects = [];
    let nextIndex = 0;

    for (let step = 1; step <= count; step++) {
        nextIndex = start + step;
        // If we have hit the end
        if (nextIndex === projects.length) {
            nextIndex = 0;
            // If we are past the end
        } else if (nextIndex > projects.length) {
            nextIndex = step;
        }

        if (projects[nextIndex]) {
            nextProjects.push(projects[nextIndex]);
        }
    }

    return nextProjects;
}

function getPreviousProjects(projects, start, count) {
    let previousProjects = [];
    let nextIndex = 0;

    for (let step = -1; step >= -count; step--) {
        nextIndex = start + step;

        // If we have hit the bottom
        if (nextIndex < 0) {
            nextIndex = projects.length + nextIndex;
        }

        if (projects[nextIndex]) {
            previousProjects.push(projects[nextIndex]);
        }
    }

    return previousProjects;
}

function getRelatedProjects(slug, projects) {
    let project = null;
    let projectIndex = 0;
    let relatedProjects = [];

    if (projects.length) {
        // Get project
        project = projects.find(item => {
            return item.fields.slug === slug;
        });
        // Get index
        projectIndex = projects.indexOf(project);

        // Related projects
        relatedProjects = getNextProjects(projects, projectIndex, 2).concat(
            getPreviousProjects(projects, projectIndex, 2)
        );
    }

    return relatedProjects;
}

const mapStateToProps = (state, ownProps) => {
    let slug = ownProps.match.params.id;
    let projects = state.projects.all;
    let relatedProjects = getRelatedProjects(slug, projects);

    return {
        projects: relatedProjects,
        hasError: state.projects.hasError,
        hasLoaded: state.projects.hasLoaded,
        isLoading: state.projects.isLoading
    };
};

otherProjectsContainer = withRouter(
    connect(mapStateToProps, { fetchProjectsIfNeeded })(otherProjectsContainer)
);

export default otherProjectsContainer;



// WEBPACK FOOTER //
// ./src/data/containers/otherProjects.js